<template>
<div class="subpage__body">
  <section>
  <h2>Skills</h2>
  <ul class="skills_list">
    <li>HTML, CSS, SASS</li>
    <li>Javascript, Typescript</li>
    <li>React, Next</li>
    <li>Vue</li>
    <li>API:s (REST, JSON)</li>
    <li>Node, express</li>
    <li>Headless CMS</li>
    <li>Database querying (SQL, NoSQL)</li> 
    <li>Agile methods</li>
    <li>Graphic design</li>
    <li>UX</li>
    <li>Accessibility</li>
  </ul>
</section>
</div>
</template>